#import "../fragments/tag-count-fragment.graphql"

mutation UpdateLeadTags($lead: UpdateLeadInputFieldInput!) {
    updateLead(input: {lead: $lead}) {
        lead {
            id
            tagMaps(first: 1000) {
                edges {
                    creator {
                        id
                        name
                    }
                    createdTime
                    node {
                        ...TagCount
                    }
                }
            }
        }
    }
}
